import { Component, OnInit } from '@angular/core';
import { CancelBeegoAppointmentComponent } from '@internal-components/beego-appointment-components/cancel-beego-appointment-component/cancel-beego-appointment.component';
import { IBeegoAppointment } from '@internal-models/beego-appointment.model';
import { PrintingProvider } from '@internal-providers/printing.provider';
import { InternalNavigationType } from '@shared-directives/navigate.directive';
import {
	Action,
	ExtBeegoAppointmentStatus,
	BeegoAppointmentStatus,
	NavigationDataKey,
	NavigationType,
	PaymentMethod,
} from '@shared-libs/enums';
import { NavigationService } from '@shared-services/navigation.service';
import { PrintingService } from '@shared-services/print.service';
import { addHours, isAfter } from 'date-fns';

@Component({
	selector: 'beego-appointment-details-desktop-component',
	templateUrl: 'beego-appointment-details.desktop.component.html',
	styleUrls: ['./beego-appointment-details.desktop.component.scss'],
})
export class BeegoAppointmentDetailsDesktopComponent implements OnInit {
	public beegoAppointment: IBeegoAppointment;
	public isInPast: boolean;
	public mapIsReady: boolean;
	public appointmentDate: Date;
	public appointmentBufferEnd: Date;
	public action: Action;

	public readonly InternalNavigationType: typeof InternalNavigationType = InternalNavigationType;
	public readonly BeegoAppointmentStatus: typeof BeegoAppointmentStatus = BeegoAppointmentStatus;
	public readonly ExtBeegoAppointmentStatus: typeof ExtBeegoAppointmentStatus = ExtBeegoAppointmentStatus;

	constructor(
		private readonly navigationService: NavigationService,
		private readonly printingProvider: PrintingProvider,
		private readonly printingService: PrintingService
	) {}

	public async ngOnInit(): Promise<void> {
		this.action = Action.DELETE;
		this.beegoAppointment = this.navigationService.getNavigationData(NavigationDataKey.beegoAppointment);

		this.appointmentDate = new Date(
			this.beegoAppointment.WorkOrder.CalendarEvent
				? this.beegoAppointment.WorkOrder.CalendarEvent.startsAt
				: `${this.beegoAppointment.WorkOrder.Appointment.appointmentDate} ${this.beegoAppointment.WorkOrder.Appointment.appointmentTime}`
		);

		this.isInPast = !isAfter(this.appointmentDate, new Date());
		this.appointmentBufferEnd = addHours(this.appointmentDate, 2);
	}

	public async print(): Promise<void> {
		const html = await this.printingProvider.getHTMLConfirmationForBeegoAppointment(
			this.beegoAppointment.AppointmentId
		);
		await this.printingService.print(html);
	}

	public async deleteAppointment(): Promise<void> {
		await this.navigationService.navigateTo<{
			action: Action;
		}>(NavigationType.modal, CancelBeegoAppointmentComponent, { beegoAppointment: this.beegoAppointment });
	}

	public getPaymentMethodIcon(method: PaymentMethod): string {
		switch (method) {
			case PaymentMethod.Cash:
				return 'cash-outline';
			case PaymentMethod.SumUp:
			case PaymentMethod.Digicheque:
				return 'credit-card-outline';
			case PaymentMethod.DirectDebit:
				return 'direct-debit-outline';
			case PaymentMethod.Qr:
				return 'qr-outline';
			case PaymentMethod.Transfer:
				return 'transfer-outline';
			default:
				return 'cash-outline';
		}
	}

	public close(): void {
		this.navigationService.navigateBack();
	}
}
